import { AGENT_TYPES as T } from "../../models/agentic/dist/src/AgentType.js";
const p = 2e3, o = (e) => e.toISOString().split(".")[0] + "Z", i = (e) => {
  const t = /* @__PURE__ */ new Date(), n = new Date(t.getTime() - (e + 1) * 24 * 60 * 60 * 1e3);
  return {
    id: `agent-${e + 1}`,
    name: `Conversational Agent ${e + 1}`,
    description: e % 2 === 0 ? `Description for agent ${e + 1}` : "",
    agentType: T.CRGA,
    passageRetrievalModelId: `passage-model-${e % 3 + 1}`,
    answerGenerationModelId: `answer-model-${e % 3 + 1}`,
    numberOfItemsToConsider: e % 2 === 0 ? 50 + e * 5 : void 0,
    followUpEnabled: !0,
    createdDate: o(n),
    modifiedDate: o(t)
  };
}, M = (e, t) => {
  const n = (t == null ? void 0 : t.page) ?? 0, a = (t == null ? void 0 : t.perPage) ?? 25, s = Array.from({ length: e }, (l, c) => i(c));
  t != null && t.sortingType && s.sort((l, c) => {
    const w = l[t.sortingType], D = c[t.sortingType], g = String(w ?? "").localeCompare(String(D ?? ""));
    return t.sortingOrder === "DSC" ? -g : g;
  });
  const d = n * a, m = s.slice(d, d + a), f = Math.ceil(e / a);
  return {
    pagination: {
      page: n,
      perPage: a,
      totalItems: e,
      totalPages: f
    },
    items: m
  };
}, y = (e) => {
  const t = o(/* @__PURE__ */ new Date());
  return {
    id: `agent-${Date.now()}`,
    name: e.name,
    description: e.description ?? "",
    agentType: e.agentType,
    passageRetrievalModelId: e.passageRetrievalModelId,
    answerGenerationModelId: e.answerGenerationModelId,
    numberOfItemsToConsider: e.numberOfItemsToConsider,
    followUpEnabled: e.followUpEnabled,
    createdDate: t,
    modifiedDate: t
  };
};
let r = [];
const A = (e = 5) => {
  r = Array.from({ length: e }, (t, n) => i(n));
}, S = (e, t) => {
  const n = r.findIndex((a) => a.id === e);
  return n === -1 ? null : (r[n] = {
    ...r[n],
    ...t,
    modifiedDate: o(/* @__PURE__ */ new Date())
  }, r[n]);
}, u = (e, t = p) => new Promise((n) => {
  setTimeout(() => n(e), t);
});
A(5);
export {
  y as createMockAgentFromRequest,
  i as createMockAgentItem,
  M as createMockAgentListResponse,
  A as initializeMockAgentStore,
  S as updateMockAgent,
  u as withDelay
};
//# sourceMappingURL=AgentConfigurationResource.mocks.js.map
